<script>
import AutoComplete from "primevue/autocomplete";

export default {
    name: "AdaptersAutoComplete",
    extends: AutoComplete,
    props: {
        appendTo: {
            type: String,
            required: false,
            default: '#keysoApp'
        }
    }
}
</script>
